/* eslint-disable react/react-in-jsx-scope */
// import { Link, useNavigate, redirect } from "react-router"
// import { useAuth } from "./AuthProvider";
import { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import BarChartBox from "./barChartBox/BarChartBox";
import StackedBarChartBox from "./stackedBarChartBox/StackedBarChartBox";
import BigChartBox from "./bigChartBox/BigChartBox";
import ChartBox from "./chartBox/ChartBox";
import PieChartBox from "./pieCartBox/PieChartBox";
import TopBox from "./topBox/TopBox";
// import {
//   barChartBoxRevenue,
//   barChartBoxVisit,
//   chartBoxConversion,
//   chartBoxProduct,
//   chartBoxRevenue,
//   chartBoxUser,
// } from "../data";
import axios from 'axios';

import "./home.css";

const apiurl = `${process.env.REACT_APP_API}`;
const imgurl = `${process.env.REACT_APP_URL}/image/products`

function numberWithCommas (nStr) {
    nStr += '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
};


const Dashboard = () => {
  const [dailyCus, setdailyCus] = useState(null);
  const [monthlyCus, setMonthlyCus] = useState(null);
  const [dailyUser, setdailyUser] = useState(null);
  const [monthlyUser, setMonthlyUser] = useState(null);
  const [dailyRev, setDailyRev] = useState(null);
  const [weeklyRev, setWeeklyRev] = useState(null);
  const [monthlyRev, setMonthlyRev] = useState(null);
  const [loading, setLoading] = useState(false);

  function sumtotal(items) {
        return items.reduce((sum, item) => sum + item.total * 1, 0);
        // return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
      }


  const fetchdailyCus = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=dailycustomer`);
        // console.log(response);
        if(response.data.message==="OK") {
          setdailyCus({
            color: "#8884d8",
            icon: "/userIcon.svg",
            title: "Daily Customer",
            number: response.data.data[response.data.data.length-1].inv,
            xaxisKey: "day",
            dataKey: "inv",
            percentage: response.data.data.length-2>=0 ? response.data.data[response.data.data.length-2].inv : response.data.data[0]?.inv,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  const fetchmonthlyCus = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=monthlycustomer`);
        // console.log(response);
        if(response.data.message==="OK") {
          setMonthlyCus({
            color: "#0088FE",
            icon: "/userIcon.svg",
            title: "Monthly Customer",
            number: response.data.data[response.data.data.length-1].inv,
            xaxisKey: "month",
            dataKey: "inv",
            percentage: response.data.data.length-2>=0 ? response.data.data[response.data.data.length-2].inv : response.data.data[0]?.inv,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  const fetchdailyUser = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=todaycashier`);
        // console.log(response);
        if(response.data.message==="OK") {
          setdailyUser({
            color: "#00C49F",
            icon: "/userIcon.svg",
            title: "Daily User",
            // number: response.data.data[0].amount,
            xaxisKey: "total",
            yaxisKey: "cashier",
            dataKey: "total",
            // percentage: response.data.data[1].amount,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  const fetchmonthlyUser = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=monthlycashier`);
        // console.log(response);
        if(response.data.message==="OK") {
          setMonthlyUser(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  const fetchdailyRev = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=incomesumdaily`);
        // console.log(response);
        if(response.data.message==="OK") {
          setDailyRev({
            color: "#26a69a",
            icon: "/userIcon.svg",
            title: "Daily Revenue",
            number: response.data.data[response.data.data.length-1].income,
            xaxisKey: "sdate",
            yaxisKey1: "saleAmount",
            yaxisKey2: "expenses",
            dataKey: "income",
            percentage: response.data.data.length-2>=0 ? response.data.data[response.data.data.length-2].income : response.data.data[0]?.income,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  const fetchweeklyRev = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=chartweekly`);
        // console.log(response);
        if(response.data.message==="OK") {
          setWeeklyRev({
            color: "#8884d8",
            icon: "/userIcon.svg",
            title: "Weekly Revenue",
            number: response.data.data[response.data.data.length-1].total,
            xaxisKey: "day",
            yaxisKey1: "Cash",
            yaxisKey2: "ScanQR",
            dataKey: "total",
            percentage: response.data.data.length-2>=0 ? response.data.data[response.data.data.length-2].total : response.data.data[0]?.total,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };


  const fetchmonthlyRev = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=incomesummonthly`);
        // console.log(response);
        if(response.data.message==="OK") {
          setMonthlyRev({
            color: "#FFBB28",
            icon: "/userIcon.svg",
            title: "Monthly Revenue",
            number: response.data.data[response.data.data.length-1].income,
            xaxisKey: "month",
            yaxisKey1: "saleAmount",
            yaxisKey2: "expenses",
            dataKey: "income",
            percentage: response.data.data.length-2>=0 ? response.data.data[response.data.data.length-2].income : response.data.data[0]?.income,
            chartData: response.data.data,
          });
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchdailyCus();
    fetchmonthlyCus();
    fetchdailyUser();
    // fetchmonthlyUser();
    fetchdailyRev();
    fetchweeklyRev();
    fetchmonthlyRev();


  },[]);

  // console.log(weeklyRev);

  const user = useUserContext();

  return (
    <div className="flex p-4 overflow-y-auto justify-between  h-[calc(100vh-120px)]">
      <div className="w-full  h-[calc(100vh-120px)]">
        <h1>Welcome! {user.user?.name}</h1>
        <div className="home">
          <div className="box box1">
            <TopBox />
          </div>
          <div className="box box2 grid-flow-col">
            <ChartBox {...dailyCus} />
          </div>
          <div className="box box3">
            <ChartBox {...monthlyCus} />
          </div>
          <div className="box box4">
            {dailyUser && <PieChartBox {...dailyUser} />}
          </div>
          <div className="box box5">
            <BarChartBox {...dailyRev} />
          </div>
          <div className="box box6">
            <ChartBox {...monthlyRev} />
          </div>
          <div className="box box7">
            {/* <BigChartBox /> */}
            <BigChartBox {...dailyRev} />
          </div>
          <div className="box box8">
            <StackedBarChartBox {...weeklyRev} />
          </div>
          <div className="box box9">
            <BarChartBox {...monthlyRev} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;